export const TYPE_DATAFIELD = 'datafield';
export const TYPE_SAWLINE = 'sawline';
export const TYPE_SPECIAL = 'special';
export const SAWLINE_CHAR = '☰';
export const UNICODE_FONTS = '"Arial Unicode MS", sans-serif';
export const specialOptions = [
    { label: 'Opmerkingen', key: 'product.note' },
    { label: 'Productafbeelding', key: 'product.image' },
    { label: 'Aantal', key: 'product.count' },
    { label: 'Kleur', key: 'product.color' },
];
